/**
 * @author Maxim Seredkin
 * @param {ngToastProvider} ngToastProvider
 */
export default ['ngToastProvider',
    function(ngToastProvider) {
        ngToastProvider.configure({
            animation: 'fade',
            verticalPosition: 'bottom',
            dismissButton: true,
            additionalClasses: 'text-left',
        });
    }];
